/* Carbon District premium layer: components. See the build brief. */
/* cdu-components.js (3 Nov 2026). window.CDU: skeleton, toast, drawer, modal, accordion, tooltip, reveal.
   No dependencies. Other cdu-*.js files extend window.CDU with `window.CDU = window.CDU || {}`. */
(function () {
  'use strict';
  var CDU = (window.CDU = window.CDU || {});
  if (CDU.__components) return;
  CDU.__components = true;
  CDU.version = '1.0.0';

  var doc = document, root = doc.documentElement, uid = 0;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  CDU.reducedMotion = reduced;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function el(tag, cls, attrs) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    return n;
  }
  function byId(x) { return typeof x === 'string' ? doc.getElementById(x.replace(/^#/, '')) : x; }
  function visible(n) { return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length); }
  function emit(n, name, detail) { try { n.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); } catch (e) {} }
  function fill(node, content, html) {
    if (content == null) return node;
    if (typeof content === 'string') { if (html) node.innerHTML = content; else node.textContent = content; }
    else if (content.nodeType) node.appendChild(content);
    return node;
  }
  var FOC = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"]),[contenteditable="true"]';
  function focusables(r) { return $$(FOC, r).filter(visible); }
  CDU.utils = { $: $, $$: $$, el: el, focusables: focusables, emit: emit };

  /* ---------------- layers: drawer + modal ---------------- */
  var stack = [], locks = 0;
  function lock() {
    if (locks++ === 0) {
      var sb = window.innerWidth - root.clientWidth;
      if (sb > 0) root.style.setProperty('--cdu-sbw', sb + 'px');
      root.classList.add('cdu-lock');
    }
  }
  function unlock() {
    if (--locks <= 0) { locks = 0; root.classList.remove('cdu-lock'); root.style.removeProperty('--cdu-sbw'); }
  }
  function prep(n) {
    if (n.__cduReady) return;
    n.__cduReady = true;
    if (!n.hasAttribute('role')) n.setAttribute('role', 'dialog');
    n.setAttribute('aria-modal', 'true');
    if (!n.hasAttribute('aria-label') && !n.hasAttribute('aria-labelledby')) {
      var t = $('.cdu-title', n);
      if (t) { if (!t.id) t.id = (n.id || 'cdu-layer-' + (++uid)) + '-title'; n.setAttribute('aria-labelledby', t.id); }
    }
    var p = $('.cdu-panel', n);
    if (p && !p.hasAttribute('tabindex')) p.setAttribute('tabindex', '-1');
    if (!n.classList.contains('is-open')) n.setAttribute('aria-hidden', 'true');
  }
  function openLayer(target, opts) {
    var n = byId(target);
    if (!n || n.classList.contains('is-open')) return n;
    opts = opts || {};
    prep(n);
    var rec = { el: n, opener: opts.opener || doc.activeElement, onClose: opts.onClose };
    n.__cdu = rec;
    stack.push(rec);
    lock();
    n.setAttribute('aria-hidden', 'false');
    n.classList.add('is-open');
    var panel = $('.cdu-panel', n) || n;
    var f = (opts.focus && $(opts.focus, n)) || $('[data-cdu-autofocus]', n) || panel;
    try { f.focus({ preventScroll: true }); } catch (e) {}
    emit(n, 'cdu:open');
    return n;
  }
  function closeLayer(target) {
    var n = byId(target);
    if (!n || !n.classList.contains('is-open')) return n;
    var rec = n.__cdu || {};
    n.classList.remove('is-open');
    n.setAttribute('aria-hidden', 'true');
    var i = stack.indexOf(rec);
    if (i > -1) stack.splice(i, 1);
    unlock();
    var back = rec.opener;
    if (back && back.focus && doc.contains(back) && (doc.activeElement === doc.body || n.contains(doc.activeElement) || !doc.activeElement)) {
      try { back.focus({ preventScroll: true }); } catch (e) {}
    } else if (n.contains(doc.activeElement)) {
      try { doc.activeElement.blur(); } catch (e) {}
    }
    emit(n, 'cdu:close');
    if (typeof rec.onClose === 'function') rec.onClose(n);
    if (n.hasAttribute('data-cdu-remove')) setTimeout(function () { if (n.parentNode && !n.classList.contains('is-open')) n.parentNode.removeChild(n); }, 320);
    return n;
  }
  function make(kind, o) {
    o = o || {};
    var id = o.id || 'cdu-' + kind + '-' + (++uid);
    var n = el('div', 'cdu-layer cdx cdu-' + kind,   /* .cdx scopes the theme's .btn, .chip and link styles inside the layer */ { id: id, role: o.role || 'dialog', 'aria-modal': 'true', 'aria-hidden': 'true' });
    if (kind === 'drawer') n.setAttribute('data-side', o.side || 'right');
    if (kind === 'modal' && o.size) n.setAttribute('data-size', o.size);
    if (o.remove) n.setAttribute('data-cdu-remove', '');   /* remove:true deletes the layer after it closes */
    var scrim = el('div', 'cdu-scrim', { 'data-cdu-close': '' });
    var panel = el('div', 'cdu-panel', { tabindex: '-1' });
    var hd = el('header', 'cdu-hd');
    var title = el('h2', 'cdu-title', { id: id + '-title' });
    title.textContent = o.title || '';
    n.setAttribute('aria-labelledby', title.id);
    hd.appendChild(title);
    hd.appendChild(el('button', 'cdu-x', { type: 'button', 'aria-label': o.closeLabel || 'Close', 'data-cdu-close': '' }));
    var bd = fill(el('div', 'cdu-bd'), o.content, o.html);
    panel.appendChild(hd);
    panel.appendChild(bd);
    if (o.footer != null) panel.appendChild(fill(el('div', 'cdu-ft'), o.footer, o.html));
    n.appendChild(scrim);
    n.appendChild(panel);
    doc.body.appendChild(n);
    prep(n);
    return n;
  }
  function layerApi(kind) {
    var api = {
      open: openLayer,
      close: closeLayer,
      toggle: function (t, o) { var n = byId(t); return n && n.classList.contains('is-open') ? closeLayer(n) : openLayer(n, o); },
      isOpen: function (t) { var n = byId(t); return !!(n && n.classList.contains('is-open')); },
      closeAll: function () { stack.slice().reverse().forEach(function (r) { closeLayer(r.el); }); },
      create: function (o) {
        var n = make(kind, o);
        var inst = { el: n, id: n.id, open: function (oo) { return openLayer(n, oo); }, close: function () { return closeLayer(n); } };
        if (!o || o.open !== false) openLayer(n, { onClose: o && o.onClose, focus: o && o.focus });
        else if (o && o.onClose) n.__cdu = { el: n, onClose: o.onClose };
        return inst;
      }
    };
    return api;
  }
  CDU.drawer = layerApi('drawer');
  CDU.modal = layerApi('modal');
  /* CDU.modal.confirm({title, message, confirmLabel, cancelLabel}) -> Promise<boolean> */
  CDU.modal.confirm = function (o) {
    o = o || {};
    return new Promise(function (resolve) {
      var done = false;
      var foot = el('div', null);
      foot.style.display = 'contents';
      var ok = el('button', 'btn', { type: 'button', 'data-cdu-autofocus': '' });
      ok.textContent = o.confirmLabel || 'Confirm';
      var no = el('button', 'btn btn--ghost', { type: 'button' });
      no.textContent = o.cancelLabel || 'Cancel';
      foot.appendChild(no); foot.appendChild(ok);
      var inst = CDU.modal.create({ title: o.title || '', content: o.message || '', footer: foot, size: 'sm', remove: true, onClose: function () { if (!done) { done = true; resolve(false); } } });
      ok.addEventListener('click', function () { if (!done) { done = true; resolve(true); } inst.close(); });
      no.addEventListener('click', function () { inst.close(); });
    });
  };

  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cdu-open],[data-cdu-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-cdu-open')) {
      var id = t.getAttribute('data-cdu-open') || (t.getAttribute('href') || '').replace(/^#/, '');
      var n = byId(id);
      if (n && n.classList.contains('cdu-layer')) { e.preventDefault(); openLayer(n, { opener: t, focus: t.getAttribute('data-cdu-focus') }); }
      return;
    }
    var ref = t.getAttribute('data-cdu-close');
    var layer = ref ? byId(ref) : t.closest('.cdu-layer');
    if (layer) { e.preventDefault(); closeLayer(layer); }
  });
  doc.addEventListener('keydown', function (e) {
    var top = stack[stack.length - 1];
    if (!top) return;
    if (e.key === 'Escape' && !top.el.hasAttribute('data-cdu-static')) { e.preventDefault(); closeLayer(top.el); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(top.el), panel = $('.cdu-panel', top.el) || top.el;
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (e.shiftKey && (a === first || a === panel || !top.el.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !top.el.contains(a))) { e.preventDefault(); first.focus(); }
  });
  doc.addEventListener('focusin', function (e) {
    var top = stack[stack.length - 1];
    if (!top || top.el.contains(e.target) || (e.target.closest && e.target.closest('.cdu-toasts'))) return;
    var f = focusables(top.el);
    (f[0] || $('.cdu-panel', top.el) || top.el).focus({ preventScroll: true });
  });

  /* ---------------- toast ----------------
     CDU.toast('Added to basket') or CDU.toast({message, type:'success|error|info', duration, action:{label,onClick}}) */
  var tbox;
  function toast(o) {
    if (typeof o === 'string') o = { message: o };
    o = o || {};
    if (!tbox || !doc.body.contains(tbox)) { tbox = el('div', 'cdu-toasts', { role: 'region', 'aria-label': o.regionLabel || 'Notifications' }); doc.body.appendChild(tbox); }
    var type = o.type || 'success';
    var n = el('div', 'cdu-toast', { role: type === 'error' ? 'alert' : 'status', 'data-type': type });
    var msg = el('span', 'cdu-toast__msg'); msg.textContent = o.message || '';
    n.appendChild(msg);
    var timer, left, started, gone = false;
    function dismiss() {
      if (gone) return; gone = true; clearTimeout(timer);
      if (reduced()) { if (n.parentNode) n.parentNode.removeChild(n); return; }
      n.classList.add('is-out');
      setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 200);
    }
    if (o.action && o.action.label) {
      var a = el('button', 'cdu-toast__act', { type: 'button' }); a.textContent = o.action.label;
      a.addEventListener('click', function () { if (typeof o.action.onClick === 'function') o.action.onClick(); dismiss(); });
      n.appendChild(a);
    }
    if (o.dismissible !== false) {
      var x = el('button', 'cdu-x', { type: 'button', 'aria-label': o.dismissLabel || 'Dismiss' });
      x.addEventListener('click', dismiss); n.appendChild(x);
    }
    var dur = o.duration == null ? (type === 'error' ? 8000 : 4000) : o.duration;
    function start(ms) { if (dur <= 0) return; left = ms; started = Date.now(); timer = setTimeout(dismiss, ms); }
    function pause() { clearTimeout(timer); if (started) left = Math.max(800, left - (Date.now() - started)); }
    n.addEventListener('mouseenter', pause); n.addEventListener('focusin', pause);
    n.addEventListener('mouseleave', function () { start(left || dur); }); n.addEventListener('focusout', function () { start(left || dur); });
    tbox.appendChild(n);
    var all = $$('.cdu-toast:not(.is-out)', tbox);
    while (all.length > 3) { var old = all.shift(); if (old.parentNode) old.parentNode.removeChild(old); }
    start(dur);
    return { el: n, dismiss: dismiss };
  }
  ['success', 'error', 'info'].forEach(function (t) { toast[t] = function (m, o) { o = o || {}; o.message = m; o.type = t; return toast(o); }; });
  toast.clear = function () { if (tbox) tbox.innerHTML = ''; };
  CDU.toast = toast;

  /* ---------------- skeleton ----------------
     CDU.skeleton.cards(container, 4) / .lines(container, 3) / .clear(container) / .wrap(container, promise, {cards:4}) */
  function skelCard() {
    var c = el('div', 'cdu-skel-card', { 'data-cdu-skel': '', 'aria-hidden': 'true' });
    c.appendChild(el('span', 'cdu-skel cdu-skel--img'));
    c.appendChild(el('span', 'cdu-skel cdu-skel--title'));
    c.appendChild(el('span', 'cdu-skel cdu-skel--text'));
    return c;
  }
  CDU.skeleton = {
    cards: function (container, n) {
      container = byId(container); if (!container) return;
      container.setAttribute('aria-busy', 'true');
      for (var i = 0; i < (n || 4); i++) container.appendChild(skelCard());
    },
    lines: function (container, n) {
      container = byId(container); if (!container) return;
      container.setAttribute('aria-busy', 'true');
      var w = el('div', null, { 'data-cdu-skel': '', 'aria-hidden': 'true' });
      for (var i = 0; i < (n || 3); i++) w.appendChild(el('span', 'cdu-skel cdu-skel--text'));
      container.appendChild(w);
    },
    clear: function (container) {
      container = byId(container); if (!container) return;
      $$('[data-cdu-skel]', container).forEach(function (s) { s.parentNode.removeChild(s); });
      container.removeAttribute('aria-busy');
    },
    wrap: function (container, promise, o) {
      var self = CDU.skeleton; o = o || {};
      if (o.lines) self.lines(container, o.lines); else self.cards(container, o.cards || 4);
      var end = function () { self.clear(container); };
      return Promise.resolve(promise).then(function (v) { end(); return v; }, function (e) { end(); throw e; });
    }
  };

  /* ---------------- accordion ----------------
     Native <details class="cdu-acc__item"> inside [data-cdu-acc]. Add data-exclusive for one open at a time. */
  function accItem(x) { var n = byId(x); return n && n.tagName === 'DETAILS' ? n : null; }
  CDU.accordion = {
    open: function (x) { var d = accItem(x); if (d) d.open = true; return d; },
    close: function (x) { var d = accItem(x); if (d) d.open = false; return d; },
    toggle: function (x) { var d = accItem(x); if (d) d.open = !d.open; return d; },
    openAll: function (g) { $$('details', byId(g) || doc).forEach(function (d) { d.open = true; }); },
    closeAll: function (g) { $$('details', byId(g) || doc).forEach(function (d) { d.open = false; }); },
    init: accInit
  };
  function accInit(scope) {
    $$('[data-cdu-acc][data-exclusive]', scope || doc).forEach(function (a) {
      var name = a.getAttribute('data-name') || 'cdu-acc-' + (++uid);
      $$('details', a).forEach(function (d) { if (!d.name) d.name = name; });
    });
  }
  doc.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || 'name' in d) return;       /* native exclusive handles supported browsers */
    var g = d.closest('[data-cdu-acc][data-exclusive]');
    if (g) $$('details[open]', g).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ---------------- tooltip ----------------
     <button data-cdu-tip="Text" data-pos="top|bottom">. Add a matching title for no-JS browsers: the script moves it. */
  var tip, tipFor, tipShow, tipHide, tipAuto;
  function tipEl() {
    if (!tip) {
      tip = el('div', 'cdu-tip', { role: 'tooltip', id: 'cdu-tip', 'aria-hidden': 'true' });
      tip.addEventListener('mouseenter', function () { clearTimeout(tipHide); });
      tip.addEventListener('mouseleave', function () { hideTip(); });
      doc.body.appendChild(tip);
    }
    return tip;
  }
  function tipText(t) {
    var s = t.getAttribute('data-cdu-tip');
    if (t.hasAttribute('title')) { if (!s) s = t.getAttribute('title'); t.setAttribute('data-cdu-title', t.getAttribute('title')); t.removeAttribute('title'); }
    return s;
  }
  function placeTip(t, pos) {
    var b = tipEl(), r = t.getBoundingClientRect(), w = b.offsetWidth, h = b.offsetHeight, g = 8, vw = root.clientWidth, vh = window.innerHeight;
    var top = pos === 'bottom' ? r.bottom + g : r.top - h - g;
    if (pos !== 'bottom' && top < g) top = r.bottom + g;
    if (pos === 'bottom' && top + h > vh - g) top = r.top - h - g;
    var left = r.left + r.width / 2 - w / 2;
    left = Math.max(g, Math.min(left, vw - w - g));
    b.style.left = Math.round(left) + 'px'; b.style.top = Math.round(Math.max(g, top)) + 'px';
  }
  function showTip(t, text, pos) {
    var s = text != null ? text : tipText(t);
    if (!s) return;
    var b = tipEl();
    clearTimeout(tipHide); clearTimeout(tipAuto);
    if (tipFor && tipFor !== t) tipFor.removeAttribute('aria-describedby');
    tipFor = t;
    b.textContent = s;
    placeTip(t, pos || t.getAttribute('data-pos') || 'top');
    t.setAttribute('aria-describedby', 'cdu-tip');
    b.setAttribute('aria-hidden', 'false');
    b.classList.add('is-on');
  }
  function hideTip() {
    clearTimeout(tipShow); clearTimeout(tipHide); clearTimeout(tipAuto);
    if (tipFor) { tipFor.removeAttribute('aria-describedby'); tipFor = null; }
    if (tip) { tip.classList.remove('is-on'); tip.setAttribute('aria-hidden', 'true'); }
  }
  function tipTarget(e) { return e.target && e.target.closest ? e.target.closest('[data-cdu-tip]') : null; }
  doc.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = tipTarget(e); if (!t) return;
    clearTimeout(tipHide); clearTimeout(tipShow);
    tipShow = setTimeout(function () { showTip(t); }, 120);
  });
  doc.addEventListener('pointerout', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = tipTarget(e); if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
    clearTimeout(tipShow); clearTimeout(tipHide);
    tipHide = setTimeout(hideTip, 100);
  });
  doc.addEventListener('focusin', function (e) {
    var t = tipTarget(e);
    if (t && (!t.matches || t.matches(':focus-visible'))) showTip(t);
  });
  doc.addEventListener('focusout', function (e) { if (tipTarget(e)) hideTip(); });
  doc.addEventListener('pointerdown', function (e) {
    var t = tipTarget(e);
    if (t && e.pointerType === 'touch') { showTip(t); tipAuto = setTimeout(hideTip, 2600); }
    else if (!t && tip && tip.classList.contains('is-on') && !tip.contains(e.target)) hideTip();
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && tip && tip.classList.contains('is-on')) hideTip(); });
  window.addEventListener('scroll', function () { if (tip && tip.classList.contains('is-on')) hideTip(); }, { passive: true });
  window.addEventListener('resize', hideTip);
  CDU.tooltip = {
    show: function (t, text, pos) { t = byId(t); if (t) showTip(t, text, pos); },
    hide: hideTip,
    attach: function (t, text, pos) { t = byId(t); if (!t) return; t.setAttribute('data-cdu-tip', text); if (pos) t.setAttribute('data-pos', pos); }
  };

  /* ---------------- motion: scroll reveal + image fade ----------------
     <div data-cdu-reveal> (rise) or data-cdu-reveal="fade". Parent with data-cdu-stagger reveals its children in turn.
     Elements already on screen at load are never hidden. */
  var io, active = false, queued = false;
  function inView(n) { var r = n.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function markIn(n) { n.classList.add('is-in'); }
  function observeReveal(n) {
    if (n.__cduSeen) return; n.__cduSeen = true;
    if (!active || inView(n)) { markIn(n); return; }
    io.observe(n);
  }
  function fadeImg(img) {
    if (img.__cduFade || img.complete || !active) return;
    if (img.matches('[data-cdu-nofade],[fetchpriority="high"],[loading="eager"],.hero img') || (img.hasAttribute('loading') === false && !img.hasAttribute('data-cdu-fade'))) return;
    if (inView(img) && !img.hasAttribute('data-cdu-fade')) return;
    img.__cduFade = true;
    img.classList.add('cdu-fade-pending');
    var done = function () { img.removeEventListener('load', done); img.removeEventListener('error', done); clearTimeout(t); if (img.classList.contains('cdu-fade-pending')) { img.classList.remove('cdu-fade-pending'); img.classList.add('cdu-fade-in'); } };
    var t = setTimeout(done, 4000);
    img.addEventListener('load', done); img.addEventListener('error', done);
  }
  function scan(scope) {
    scope = scope && scope.querySelectorAll ? scope : doc;
    $$('[data-cdu-stagger]', scope).forEach(function (p) {
      if (p.__cduStag) return; p.__cduStag = true;
      Array.prototype.slice.call(p.children).forEach(function (c, i) {
        if (!c.hasAttribute('data-cdu-reveal')) c.setAttribute('data-cdu-reveal', '');
        c.style.setProperty('--cdu-delay', Math.min(i, 6) * 48 + 'ms');
      });
    });
    $$('[data-cdu-reveal]', scope).forEach(observeReveal);
    $$('img[loading="lazy"],img[data-cdu-fade]', scope).forEach(fadeImg);
  }
  function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; scan(); }, 120); }
  CDU.reveal = {
    scan: scan,
    show: function (n) { n = byId(n); if (n) markIn(n); },
    observe: function (n) { n = byId(n); if (n) observeReveal(n); }
  };
  /* Accessibility shims. (1) aria-pressed is not valid on links: mirror it to aria-current. (2) A closed dialog that is only
     aria-hidden still holds focusable controls: make it inert while hidden. */
  function a11y() {
    function fixChip(el) {
      var v = el.getAttribute('aria-pressed');
      if (v === null) return;
      el.setAttribute('aria-current', v === 'true' ? 'true' : 'false');
      el.removeAttribute('aria-pressed');
    }
    function fixDlg(el) { if ('inert' in el) el.inert = el.getAttribute('aria-hidden') === 'true'; }
    function sweep(rootEl) {
      $$('a[aria-pressed]', rootEl).forEach(fixChip);
      $$('[role="dialog"][aria-hidden]', rootEl).forEach(fixDlg);
    }
    try {
      sweep(doc);
      if ('MutationObserver' in window) new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var m = ms[i], t = m.target;
          if (m.type === 'attributes') {
            if (m.attributeName === 'aria-pressed' && t.tagName === 'A') fixChip(t);
            else if (m.attributeName === 'aria-hidden' && t.getAttribute && t.getAttribute('role') === 'dialog') fixDlg(t);
          } else if (m.addedNodes.length) { for (var j = 0; j < m.addedNodes.length; j++) { var n = m.addedNodes[j]; if (n.nodeType === 1) { if (n.tagName === 'A' && n.hasAttribute('aria-pressed')) fixChip(n); sweep(n); } } }
        }
      }).observe(doc.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-hidden'] });
    } catch (e) {}
  }
  function boot() {
    try {
      active = !reduced() && 'IntersectionObserver' in window;
      if (active) io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { markIn(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px' });
      scan();
      root.classList.add('cdu-js');                  /* hide rules apply only from here, and only when active */
      if (active && 'MutationObserver' in window) new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { schedule(); return; }
      }).observe(doc.body, { childList: true, subtree: true });
    } catch (e) { root.classList.remove('cdu-js'); $$('[data-cdu-reveal]').forEach(markIn); $$('img.cdu-fade-pending').forEach(function (i) { i.classList.remove('cdu-fade-pending'); }); }
    a11y();
    accInit();
    $$('.cdu-layer').forEach(prep);
    var h = decodeURIComponent((location.hash || '').slice(1));
    if (h) {
      var t = doc.getElementById(h);
      if (t && t.classList.contains('cdu-layer')) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} openLayer(t); }
      else if (t && t.tagName === 'DETAILS' && t.classList.contains('cdu-acc__item')) t.open = true;
    }
    root.setAttribute('data-cdu', CDU.version);
    emit(doc, 'cdu:ready');
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
